import axios from 'axios'

export default class ApiManagerFood {
    /**
     * create campaigne email
     */
    static async campaigneEmailsStore(payload) {
        return axios.post('/back-office/campaigne-emails/store', payload).then((res) => res)
    }

    /**
     * fetch campaigne email
     */
    static async campaigneEmailsFetch(params) {
        return axios.get('/back-office/campaigne-emails', { params: params }).then((res) => res.data)
    }

    /**
     * show campaigne email by uuid
     */
    static async campaigneShow(uuid, params) {
        return axios.get(`/back-office/campaigne-emails/show/${uuid}`, { params: params }).then((res) => res.data)
    }

    /**
     * confirm campaigne email
     */
    static async campaigneEmailsConfirm(payload) {
        return axios.post('/back-office/campaigne-emails/confirm', payload).then((res) => res.data)
    }

    /**
     * send campaigne email
     */
    static async send(uuid, payload) {
        return axios.post(`/back-office/campaigne-emails/send/${uuid}`, payload).then((res) => res.data)
    }

    /**
     * send campaigne email for test
     */
    static async sendEmailForTest(uuid, payload) {
        return axios.post(`/back-office/campaigne-emails/send/test/${uuid}`, payload).then((res) => res.data)
    }

    /**
     * delete campaigne email
     */
    static async destroy(uuid) {
        return axios.delete(`/back-office/campaigne-emails/destroy/${uuid}`).then((res) => res)
    }

    /**
     * statistic campaigne email
     */
    static async fetchListEmails(params) {
        return axios.get(`/back-office/campaigne-emails/statistic`, { params: params }).then((res) => res.data)
    }

    /**
     * get customers list for campaigne email
     */
    static async fetchSendedEmailCampaigneCustomers(params) {
        return axios
            .get(`/back-office/campaigne-emails/statistic/recived-customers`, { params })
            .then((res) => {
                return res.data.data
            })
            .catch((error) => {
                console.error('Error fetching email customer list', error)
                throw error
            })
    }
}
